
const modal = document.querySelector('.webinar-modal');
const form = document.querySelector('#webinarForm');
const submitBtn = document.querySelector('.webinar-modal__submit');
const errorBlock = document.querySelector('.webinar-modal__error');
const closeBtn = document.querySelector('.webinar-modal__close');
const videoModal = document.querySelector('.webinar-video');
const iframe = document.querySelector('.webinar-video__frame');
const country = document.querySelector('.webinar-modal__country .js-select__current');
const html = document.querySelector('html')
const videoUrl = ''
let currentVideos = {};


submitBtn.addEventListener('click', async (e) => {
    e.preventDefault();
    errorBlock.textContent = '';
    errorBlock.style.display = 'none';

    const formData = new FormData(form);

    const data = {
        action: 'webinar_form',
        lang: formData.get('lang'),
        about: formData.get('about'),
        first_name: formData.get('first_name').trim(),
        email: formData.get('email').trim(),
        phone: formData.get('phone').trim(),
        country: country.textContent.trim(),
        // message: formData.get('message').trim(),
    };

    if (!data.first_name) {
        showError('First name is required');
        return;
    }

    if (!data.email) {
        showError('Email is required');
        return;
    }

    if (!validateEmail(data.email)) {
        showError('Enter valid email');
        return;
    }

    // if (!data.phone) {
    //     showError('Phone Number is required');
    //     return;
    // }

   if (!data.country || data.country === 'Select country') {
    showError('Country is required');
    return;
}

    try {
        submitBtn.classList.add('loaded')
        const formData = new FormData();

        Object.entries(data).forEach(([key, value]) => {
          formData.append(key, value);
        });
        
        const response = await fetch(myajax.url, {
          method: 'POST',
          body: formData
        });
        const result = await response.json();


        const videoUrl = currentVideos[data.lang];
        modal.classList.remove('active')
        playVideo(videoUrl.url);
        console.log(videoUrl);

        if (result.success) {
            form.reset();
            showError('Success!', true);
        } else {
            showError(result.data || 'Something went wrong');
        }

    } catch (err) {
        console.error(err);
        showError('Request failed');
    }

    submitBtn.classList.remove('loaded')
});

function showError(message, isSuccess = false) {
    console.log('err');
    
    errorBlock.textContent = message;
    errorBlock.style.display = 'block';
    errorBlock.style.color = isSuccess ? 'green' : 'red';
}

function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

const radioWrappers = document.querySelectorAll('.webinar-modal__radio');
radioWrappers.forEach(wrapper => {
    wrapper.addEventListener('click', () => {
        const input = wrapper.querySelector('input[type="radio"]');
        if (input) {
            input.checked = true;
        }
    });
});

closeBtn.addEventListener('click', () => {
    modal.classList.remove('active')
    html.classList.remove('hidden')
})

modal.addEventListener('click', (e) => {
    if (!form.contains(e.target)) {
        modal.classList.remove('active');
        html.classList.remove('hidden')
    }
});


document.addEventListener('click', (e) => {
    const btn = e.target.closest('.list-template__webinar-btn');
    if (!btn) return;
    errorBlock.textContent = ''

    currentVideos = JSON.parse(btn.dataset.videos || '{}');
    html.classList.add('hidden')
    radioWrappers.forEach(wrapper => {
        const input = wrapper.querySelector('input[name="lang"]');
        if (!input) return;

        if (currentVideos[input.value]) {
            wrapper.style.display = 'flex';
        } else {
            wrapper.style.display = 'none';
            input.checked = false;
        }
    });

    const first = Object.keys(currentVideos)[0];
    if (first) {
        const input = document.querySelector(`input[name="lang"][value="${first}"]`);
        if (input) input.checked = true;
    }

    modal.classList.add('active');
}); 

function getYoutubeEmbed(url) {
    try {
        const u = new URL(url);

        if (u.hostname.includes('youtu.be')) {
            return `https://www.youtube.com/embed/${u.pathname.slice(1)}`;
        }

        if (u.hostname.includes('youtube.com')) {
            return `https://www.youtube.com/embed/${u.searchParams.get('v')}`;
        }

        return null;
    } catch (e) {
        return null;
    }
}

function playVideo(url) {
    console.log(url);

    const embed = getYoutubeEmbed(url);
    console.log(embed);

    if (!embed) return;

    iframe.src = embed + '?autoplay=1';
    videoModal.classList.add('active');
}

function stopVideo() {
    iframe.src = '';
    videoModal.classList.remove('active');
    html.classList.remove('hidden')
}

videoModal.addEventListener('click', (e) => {
    if (e.target === videoModal) {
        stopVideo();
    }
});